/* @flow */
import React from 'react';

import BirthdateModalSectionMixin from 'chat/components/mixins/BirthdateModalSectionMixin.jsx';
import BirthdateSelector from './BirthdateSelector.jsx';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';

/**
 * The actual render is in BirthdateModalSectionMixin
 */
/* eslint-disable react/require-render-return */
const AskForBirthdate = React.createClass({
  mixins: [BirthdateModalSectionMixin],

  getInitialState(): {birthdate?: Date} {
    return {
      birthdate: undefined,
    };
  },

  onSubmit() {
    if (!this.state.birthdate) {
      console.error('ignoring birthdate form submission with null birthdate');
      return;
    }

    const onError = response => {
      const errors = {};

      for (const field of response['field_errors']) {
        errors[field['field_name']] = field.messages.join(', ');
      }

      if ('birthdate' in errors) {
        ToastActions.showErrorToast(errors['birthdate']);
      }
    };

    UserActions
      .setBirthdate(this.state.birthdate)
      .then(() => {}, onError);
  },

  birthdateChanged(birthdate: Date) {
    this.setState({ birthdate });
  },

  buttonDisabled() {
    return !this.state.birthdate;
  },

  title() {
    return 'What is your date of birth?';
  },

  renderCollector() {
    return <BirthdateSelector onChange={this.birthdateChanged} />;
  },
});

export default AskForBirthdate;



// WEBPACK FOOTER //
// ./src/chat/components/AskForBirthdate.jsx